
interface KITeamProps {
  onBookingClick?: () => void;
}

export default function KITeam({ onBookingClick }: KITeamProps) {
  const teamMembers = [
    {
      image: '/images/Email-Marketing-Assistent.jpg',
      title: 'Email Assistent',
      description: 'E-Mails automatisch sortieren, klassifizieren und auf Dringlichkeit prüfen',
      benefit: 'Spart 30–60 Min/Tag pro Person, 90% weniger verpasste E-Mails'
    },
    {
      image: '/images/Content-Redaktions-Assistent.jpg',
      title: 'Content & Redaktions-Assistent',
      description: 'Newsletter, Blog-Posts und Social Media Content erstellen und planen',
      benefit: '60% schnellere Content-Produktion, 30% mehr Engagement'
    },
    {
      image: '/images/Performance-Marketing-Assistent.jpg',
      title: 'Performance Marketing Assistent',
      description: 'Kampagnen optimieren, Budgets verwalten, Ads automatisch verbessern',
      benefit: '37% bessere Ad-Performance, 25% niedrigere Kosten pro Lead'
    },
    {
      image: '/images/Lead-Qualifying-Assistent.jpg',
      title: 'Lead Qualifying Assistent',
      description: 'Leads aus Social Media erfassen, bewerten und anreichern',
      benefit: '40% mehr qualifizierte Leads'
    },
    {
      image: '/images/Sales-Proposal-Assistent.jpg',
      title: 'Sales Proposal Assistent',
      description: 'Angebote und Präsentationen automatisch erstellen und individualisieren',
      benefit: '1–2 Std pro Angebot gespart, 3x schnellere Deck-Erstellung'
    },
    {
      image: '/images/Recruiting-Interview-Assistent.jpg',
      title: 'Recruiting & Interview-Assistent',
      description: 'Interview-Notizen erstellen, Kandidaten bewerten und screenen',
      benefit: '20–30 Min gespart pro Interview, 25% mehr Screening-Calls möglich'
    },
    {
      image: '/images/Dokument-Verarbeitungs-Assistent.jpg',
      title: 'Dokument-Verarbeitungs-Assistent',
      description: 'PDFs auslesen, Daten extrahieren, Aufträge automatisch verarbeiten',
      benefit: 'Bis zu 1 Tag schneller, eliminiert manuelle Eingabefehler'
    },
    {
      image: '/images/Support-Wissensdatenbank-Assistent.jpg',
      title: 'Support & Wissensdatenbank-Assistent',
      description: 'Häufige Fragen automatisch beantworten, Self-Service ermöglichen',
      benefit: '20–40% weniger Support-Anfragen, Antwortzeit von Minuten auf Sekunden'
    },
    {
      image: '/images/Onboarding-Assitent.jpg',
      title: 'Onboarding-Assistent',
      description: 'Neue Mitarbeitende durch strukturierten Onboarding-Prozess führen',
      benefit: 'Schnelleres Onboarding, bessere Employee Experience, weniger Admin-Aufwand'
    }
  ];

  return (
    <>
      {/* Zielgruppe Section - Weiß */}
      <section className="py-20 lg:py-32 px-6 lg:px-12 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="text-sm text-[#0A6AF0] font-normal mb-2 uppercase tracking-wide">
                Zielgruppe
              </p>
              <h2 className="text-3xl lg:text-5xl text-[#042A60] mb-6 font-light">
                Für Unternehmen die nicht zurückfallen wollen
              </h2>
              <p className="text-base text-[#042A60]/80 leading-relaxed">
                Du bist Unternehmer:in oder Führungskraft und willst dein Geschäft nachhaltig erfolgreich machen – ohne ständig neues Personal aufbauen zu müssen. Mittlere Unternehmen in Österreich sind unser Schwerpunkt: Du hast Teams und Strukturen, aber zu wenig Kapazität in Marketing, Sales, HR oder Produktentwicklung, und genau da holen KI-Assistent:innen dir Spezialist:innen-Know-how ins Haus – ohne Personalkosten, Urlaubsplanung und Fluktuation.
              </p>
            </div>

            <div className="space-y-8">
              <div>
                <h3 className="text-lg font-medium text-[#042A60] mb-3">
                  Schwerpunkt: Mittlere Unternehmen
                </h3>
                <p className="text-sm text-[#042A60]/70 leading-relaxed">
                  Du hast Strukturen, Teams und Prozesse, aber zu wenig Kapazität in Marketing, Sales, HR oder Produktentwicklung. KI‑Assistent:innen holen dir Spezialist:innen‑Know-how in deine Wertschöpfungskette, ohne dass du dafür zehn neue Köpfe einstellen musst – so stärkst du Produktivität, Innovationskraft und Wettbewerbsfähigkeit am Standort Österreich.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-[#042A60] mb-3">
                  Startups & Solo-Selbstständige
                </h3>
                <p className="text-sm text-[#042A60]/70 leading-relaxed">
                  Auch wenn du ein kleineres Unternehmen führst oder soloselbstständig bist, passt klar:ki zu dir: Du professionalisierst gezielt einzelne Bereiche mit skalierbaren, bezahlbaren Use Cases – und baust dir Schritt für Schritt dein eigenes digitales Team auf.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* KI Team Section - Grau #D7D7D7 */}
      <section id="team" className="py-20 lg:py-32 px-6 lg:px-12 bg-[#D7D7D7]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-sm text-[#0A6AF0] font-normal mb-2 uppercase tracking-wide">
              Team
            </p>
            <h2 className="text-3xl lg:text-5xl text-[#042A60] mb-4 font-light">
              Deine KI-Spezialist:innen für jede Rolle
            </h2>
            <p className="text-base text-[#042A60]/70 max-w-3xl mx-auto">
              Wolltest du nicht schon immer deine eigene Performance Marketing Managerin? Deinen SEO-Experten? Deine Sales Development Rep? Mit klar:ki bekommst du KI-Assistent:innen die wie Spezialist:innen arbeiten. Das sind Beispiele – im Workshop finden wir die passenden für dein Geschäft.
            </p>
          </div>

          {/* Scrollbare Karten */}
          <div className="relative mb-12">
            <div className="overflow-x-auto pb-4 scrollbar-thin scrollbar-thumb-[#042A60]/30 scrollbar-track-transparent">
              <div className="flex gap-6" style={{ width: 'max-content' }}>
                {teamMembers.map((member, index) => (
                  <div 
                    key={index} 
                    className="bg-white overflow-hidden hover:shadow-md transition-shadow flex-shrink-0"
                    style={{ width: 'calc((100vw - 96px - 72px) / 4)', maxWidth: '280px', minWidth: '240px' }}
                  >
                    <div className="w-full h-56 bg-[#042A60] overflow-hidden">
                      <img 
                        src={member.image} 
                        alt={member.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="p-5">
                      <h3 className="text-base font-medium text-[#042A60] mb-2">
                        {member.title}
                      </h3>
                      <p className="text-sm text-[#042A60]/70 mb-3">
                        {member.description}
                      </p>
                      <p className="text-xs text-[#0A6AF0] font-medium">
                        {member.benefit}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Scroll-Hinweis */}
            <div className="flex items-center justify-center gap-2 mt-4 text-[#042A60]/60">
              <i className="ri-arrow-left-s-line text-lg"></i>
              <span className="text-sm">Scrollen für mehr</span>
              <i className="ri-arrow-right-s-line text-lg"></i>
            </div>
          </div>

          <div className="text-center">
            <p className="text-base text-[#042A60]/80 mb-6">
              Deine KI-Spezialistinnen kennenlernen?
            </p>
            <button 
              onClick={onBookingClick}
              className="px-6 py-2.5 bg-[#0A6AF0] text-white text-sm font-normal hover:bg-[#042A60] transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
            >
              Klarheitsgespräch buchen
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Warum der Mensch Section - Weiß */}
      <section className="py-20 lg:py-32 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-5xl text-[#042A60] mb-8 font-light">
            Warum der Mensch wichtiger bleibt
          </h2>
          <p className="text-base text-[#042A60]/80 leading-relaxed">
            KI nimmt dir die Fleißarbeit ab, trägt aber keine Verantwortung. Menschen setzen Ziele, treffen Entscheidungen, definieren Werte. Bei klar:ki steht human intelligence vor artificial intelligence – klare Regeln, wann KI unterstützt und wann du entscheidest. KI kann vorschlagen, du entscheidest. Das ist der Unterschied zwischen Tool und Partner.
          </p>
        </div>
      </section>

      {/* Person Section - Weiß */}
      <section id="person" className="py-20 lg:py-32 px-6 lg:px-12 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-sm text-[#0A6AF0] font-normal mb-2 uppercase tracking-wide">
                Person
              </p>
              <h2 className="text-3xl lg:text-5xl text-[#042A60] mb-6 font-light">
                Wer hinter klar:ki steht
              </h2>
              <p className="text-base text-[#042A60]/80 leading-relaxed mb-8">
                Ich bin Eva, Strategin und Übersetzerin an der Schnittstelle zwischen Business und Technologie. Meine Leidenschaft: Unternehmer:innen helfen, KI nicht als Hype zu sehen, sondern als Partner für echte Effizienz und Wachstum.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="#about"
                  className="px-6 py-2.5 bg-transparent text-[#042A60] text-sm font-normal border border-[#042A60] hover:bg-[#042A60] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Mehr über mich
                </a>
                <a 
                  href="#contact"
                  className="px-6 py-2.5 text-[#042A60] text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
                >
                  Kontakt
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="w-full h-96 lg:h-[500px] overflow-hidden">
                <img 
                  src="/images/KLAR-ki_Eva.png" 
                  alt="Eva" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
